import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const Breadcrumbs = ({ items }: { items: { label: string; to?: string }[] }) => {
  const { t } = useLanguage();
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-charcoal-400">
        <li><Link to="/" className="hover:text-clay transition-colors" data-testid="breadcrumb-home">{t.nav.home}</Link></li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5" aria-hidden />
            {item.to ? <Link to={item.to} className="hover:text-clay transition-colors">{item.label}</Link> : <span aria-current="page" className="text-charcoal">{item.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
};
